const RevenueDataTypes = {
    ECPM: "ecpm",
    REVENUE: "revenue",
    SESSIONS: "session",
}
export default RevenueDataTypes;